import { useState } from 'react';
import { useClipboard } from '@chakra-ui/react';

import i18n from '../utils/i18n';

export const COPY_TEXT = i18n.t('visualization.options.copy');
export const COPIED_TEXT = i18n.t('visualization.options.copied');

/**
 * To copy a text on click on a button, with a tooltip text displayed on hover
 * @param {string} content - the content to copy
 * @param analyticsEventName - the name of the analytics event
 * @param trackData - the data to track in analytics
 * @returns `{tooltipText, handleCopy, handleTooltipOpen}`
 */
export const useCopyWithTooltip = (
  content: string,
  analyticsEventName: string,
  trackData: Record<string, unknown>
) => {
  const { onCopy } = useClipboard(content);
  const [tooltipText, setTooltipText] = useState(COPY_TEXT);

  const handleCopy = () => {
    window.analytics.track(analyticsEventName, trackData);
    if (content.length > 0) onCopy();
    setTooltipText(COPIED_TEXT);
  };

  const handleTooltipOpen = () => {
    if (tooltipText === COPIED_TEXT) setTooltipText(COPY_TEXT);
  };

  return { tooltipText, handleCopy, handleTooltipOpen };
};
